/* istanbul ignore file */
import { UpdatePageLayout } from 'framework/ui/layout';
import { UpdateForm } from 'framework/form';
import OpportunityEntityHeader from 'domain/sales/opportunity/shared/OpportunityEntityHeader';
import UpdateOpportunityBreadcrumbs from 'domain/sales/opportunity/createupdate/UpdateOpportunity/Breadcrumbs';
import useOpportunityService from 'domain/sales/opportunity/opportunityService';
import OpportunityForm from 'domain/sales/opportunity/createupdate/OpportunityForm';
import { useOpportunityUrl } from 'domain/sales/opportunity/opportunityRouting';
import { useCompositeDocumentStorageContext, useCompositeDocumentStorageService } from 'domain/shared/documentStorage';
import { ENTITY_DOCUMENT_TYPE } from 'domain/sales/opportunity/shared/constants';

const UpdateOpportunity = () => {
  const { update, getById, getValidationSchema } = useOpportunityService();
  const { getSingleEntityUrl } = useOpportunityUrl();

  const { isDocumentStorageAvailable } = useCompositeDocumentStorageContext();
  const { commitDocument } = useCompositeDocumentStorageService(isDocumentStorageAvailable);

  const getDataMethod = async (opportunityId: StringOrNumber) => {
    const data = await getById(opportunityId);

    return {
      ...data,
      accountCodeName: data.accountName,
      accountName: data.hasAccountCodeName ? data.accountName : null,
    };
  };

  return (
    <UpdateForm
      submitFormFunc={async (opportunityId, data) => {
        const artifactPath = data?.artifactPaths;
        const commitData = await commitDocument(artifactPath, ENTITY_DOCUMENT_TYPE.ENTITY_DOCUMENT);
        return update(opportunityId, { ...data, artifactPaths: commitData });
      }}
      getDataFunc={getDataMethod}
      getValidationSchemaFunc={getValidationSchema}
      afterSubmit={{
        redirect: getSingleEntityUrl(),
        message: 'You are awesome! The Opportunity has been successfully saved.',
      }}
    >
      <UpdatePageLayout
        title="Edit: Opportunity"
        breadcrumbs={<UpdateOpportunityBreadcrumbs />}
        entityHeader={<OpportunityEntityHeader />}
      >
        <OpportunityForm />
      </UpdatePageLayout>
    </UpdateForm>
  );
};

export default UpdateOpportunity;
